<template>
    <div class="call-back-app__form-wrap">
    <form class="call-back-app__form" v-on:submit.prevent="formSubmit" method="post">

        <div class="call-back-header">
            <div class="call-back-header__title">How we can help you?</div>
            <div class="call-back-header__close-button" v-on:click="$emit('on-close-form')">✖</div>
        </div>

        <ul class="call-back-error">
            <li class="call-back-error__item" v-for="error in errors">
                {{ error[0]}}
            </li>
        </ul>

        <div class="call-back-app__body">
            <div class="call-back-app__row">
                <label class="call-back-app__label" for="first-name-call-back"><span>Name</span><span class="call-back-app__required"></span></label>
                <input required maxlength="32" name="name" v-model="formData.name" v-on:input="validateSubmit" class="call-back-app__input" id="first-name-call-back" placeholder="Your full name" type="text">
            </div>
            <input type="hidden" name="lastName">
            <div class="call-back-app__row">
                <label class="call-back-app__label" for="email-call-back"><span>Email</span><span class="call-back-app__required"></span></label>
                <input required maxlength="100" v-model="formData.emailAddress" v-on:input="validOrNotEmail" name="emailAddress" class="call-back-app__input" id="email-call-back" placeholder="example@example.com" type="email">
            </div>
            <div class="call-back-app__row">
                <label class="call-back-app__label" for="email-call-back"><span>Topic</span><span class="call-back-app__required"></span></label>
                <div class="call-back-app__select">
                    <v-select v-model="selected" :options="options" :searchable="false" label="title" placeholder="Select" v-on:change="selectHandler">
                        <template slot="option" slot-scope="option">
                            <span class="call-back-app__icon" :class="option.icon"></span>
                            {{ option.title }}
                        </template>
                    </v-select>
                </div>
            </div>
            <div class="call-back-app__row" v-if="questionActive">
                <label class="call-back-app__label" for="question-call-back">
                    Question
                    <span class="call-back-app__required"></span>
                </label>
                <textarea required maxlength="200" v-model="formData.description" v-on:input="validateSubmit" name="question" class="call-back-app__input call-back-app__textarea" id="question-call-back" placeholder="Your question" type="text"></textarea>
            </div>
            <button class="call-back-app__button" v-bind:class="{ 'call-back-app__button--active': isActive }" v-bind:disabled="!isActive">Submit</button>
        </div>
        <div class="call-back-app__footer">Your personal information will be used for contacting you regarding your inquiry.<br>By submitting this form, you agree to our <a href="/privacy-policy-full" target="_blank">Privacy Policy</a>.</div>
    </form>
    </div>
</template>

<script>
    import Util from "../../../modules/libs/Util";
    import vSelect from 'vue-select'

    export default {
        data: function () {
            return {
                formData: {
                    name: "",
                    emailAddress: "",
                    question: "",
                    company: "",
                    description: "",
                },

                options: [
                    {
                        title: 'Request a demo',
                        icon: 'call-back-app__icon--demo'
                    },
                    {
                        title: 'Ask a question',
                        icon: 'call-back-app__icon--question'
                    },
                ],

                placeholder: {
                    default: "Select",
                },

                boolEmail: false,
                isActive: false,
                selected: '',
                questionActive: false,
                selectChosen: false,
                errors: {}
            }
        },

        components: {
            vSelect,
        },

        methods: {
            setErrors(errors) {
                this.errors = errors;
            },
            validOrNotEmail: function () {
                if (Util.isEmailValid(this.formData.emailAddress)) {
                    this.boolEmail = true;
                } else {
                    this.boolEmail = false;
                }
                this.validateSubmit();
            },
            selectHandler: function () {
                this.checkIfSelectIsChosen();
                this.showQuestionField();
                this.validateSubmit();
            },
            checkIfSelectIsChosen: function (){
                if(typeof this.selected.title !== "undefined") {
                    this.selectChosen = true;
                }
            },
            showQuestionField: function () {
                if(this.selected.title == "Ask a question"){
                    this.questionActive = true;
                }
                else
                    this.questionActive = false;

            },
            validateSubmit: function () {
                if (this.questionActive) {
                    this.isActive = this.formData.name.length !== 0 && this.boolEmail && this.formData.description !== "" && this.selectChosen;
                }
                else {
                    this.isActive = this.formData.name.length !== 0 && this.boolEmail && this.selectChosen;
                }
            },
            formSubmit: function (event) {
                this.$emit('test');
                if(this.questionActive) {
                    this.formSubmitCallback('/ask-question-callback');
                }
                else {
                    this.formSubmitCallback('/demo-request-callback');
                }
            },

            formSubmitCallback: function(callbackURI) {
                axios.post(callbackURI, this.formData)
                    .then(response => {
                        this.$emit('success-send-request')
                    })
                    .catch(error => {
                        this.setErrors(error.response.data.errors);
                    });
            }
        }
    }

</script>

<style lang="scss" scoped>
    .call-back-app__form {
        display: flex;
        flex-wrap: wrap;
        width: 275px;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 0px 3px 40px 0px rgba(0, 0, 0, 0.15);
        overflow: hidden;
        z-index: 2;
    }

    .call-back-header {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        text-align: center;
        position: relative;
        width: 100%;
    }

    .call-back-header__title {
        display: block;
        width: 100%;
        padding: 32px 25px 0;
        font-weight: 500;
        line-height: 28px;
        font-size: 20px;
    }

    .call-back-header__description {
        display: block;
        width: 100%;
        padding: 15px 25px;
        line-height: 1.5;
        font-size: 14px;
        font-weight: 300;
        color: #334455;
    }

    .call-back-header__close-button {
        font-size: 14px;
        position: absolute;
        right: 17.5px;
        top: 10px;
        cursor: pointer;
        color: #C4C4C4;
    }

    .call-back-app__body {
        display: flex;
        flex-wrap: wrap;
        padding: 15px 25px;
    }

    .call-back-app__row {
        display: flex;
        flex-wrap: wrap;
        margin: 0 0 10px 0;
        width: 100%;
    }

    .call-back-app{

            &__label {
            display: flex;
            align-items: center;
            width: 100%;
            color: #334455;
            font-weight: 500;
            line-height: normal;
            font-size: 14px;
            margin: 5px 0;
        }

        &__select {
            width: 100%;
            height: 40px;
            outline: none;

            .v-select {
                .dropdown-toggle {
                    height: 40px !important;
                }
            }
        }

        &__option {
            outline: none;
            position: relative;

            &:before {
                position: absolute;
                display: block;
                content: "";
                top: 0;
                left: 0;
                width: 10px;
                height: 10px;
                background-color: red;
            }
        }
    }

    .call-back-app__required {
        display: flex;
        width: 6px;
        height: 6px;
        margin-left: 5px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        background-image: url("/dist/img/bookmark-star.svg");
    }

    .call-back-app__input {
        width: 100%;
        height: 40px;
        padding-left: 10px;
        border: 1px solid #c7d2df;
        border-radius: 2px;
    }

    .call-back-app__textarea {
        height: 110px;
        width: 100%;
        resize: none;
    }

    .call-back-app__input:focus {
        border-color: #5b9fdf;
        outline: none;
    }

    .call-back-app__input::-webkit-input-placeholder {
        font-size: 14px;
        font-weight: 300;
    }

    .call-back-app__input::-moz-placeholder {
        font-size: 14px;
        font-weight: 300;
    }

    .call-back-app__input:-moz-placeholder {
        font-size: 14px;
        font-weight: 300;
    }

    .call-back-app__input:-ms-input-placeholder {
        font-size: 14px;
        font-weight: 300;
    }

    .call-back-app__button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 45px;
        margin-top: 10px;
        padding: 5px 0;
        border: none;
        border-bottom: 2px solid #bfbbbb;
        border-radius: 4px;
        font-size: 18px;
        color: #fff;
        background-color: #dadada;
    }

    .call-back-app__button--active {
        border-color: #3e8411;
        background-color: #65b325;
    }

    .call-back-app__button--active:hover {
        background-color: #599e21;
    }

    .call-back-app__footer {
        padding: 0 25px 15px 25px;
        text-align: center;
        line-height: 1.4;
        font-size: 11px;
    }

    .call-back-error {
        margin: 0 0 -10px 0;
        padding: 0 25px;
        font-size: 13px;
        list-style: none;
        color: #cc8407;
    }

</style>



// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/callback/QuestionForm.vue